import type { VFC } from 'react';
import { Redirect, Route, Switch, useLocation, useRouteMatch } from 'react-router-dom';
import { Page as ShoppingCardPage } from './routes/hardwares/Page';
import { Page as MeterLibraryPage } from './routes/model-library/Page';
import { ShoppingCartTab } from './routes/hardwares/const';
import { Page as TemplatesPage } from './routes/templates/Page';
import { InvoicesParserTab } from '../toolbox/invoices/const';
import { PersonsPage } from './routes/persons/Page';
import { HardwarePackagesRouter } from './routes/hardware-packages/Router';
import { ModelLibraryTab } from './routes/model-library/const';
import { ManufacturerDetailPage } from './routes/model-library/routes/manufacturers/routes/detail/Page';
import { ModuleDetailPage } from './routes/model-library/routes/modules/routes/detail/Page';
import { MeterModelDetailPage } from './routes/model-library/routes/models/routes/detail/Page';

export const ResellerDataRouter: VFC = () => {
  const { path } = useRouteMatch();
  const location = useLocation();

  return (
    <Switch>
      <Route path={`${path}/model-library/module/create`} render={() => <ModuleDetailPage />} />
      <Route path={`${path}/model-library/module/:id`} render={() => <ModuleDetailPage />} />
      <Route path={`${path}/model-library/model/create`} render={() => <MeterModelDetailPage />} />
      <Route path={`${path}/model-library/model/:id`} render={() => <MeterModelDetailPage />} />
      <Route path={`${path}/model-library/manufacturer/create`} render={() => <ManufacturerDetailPage />} />
      <Route path={`${path}/model-library/manufacturer/:id`} render={() => <ManufacturerDetailPage />} />
      <Route exact path={`${path}/model-library`}>
        <Redirect to={{ pathname: `${path}/model-library/${ModelLibraryTab.Manufacturer}`, state: location.state }} />
      </Route>
      <Route path={`${path}/model-library/:tab`} render={() => <MeterLibraryPage />} />

      <Route exact path={`${path}/hardwares`}>
        <Redirect to={{ pathname: `${path}/hardwares/${ShoppingCartTab.HardwareList}`, state: location.state }} />
      </Route>
      <Route path={`${path}/hardwares/:tab`} render={() => <ShoppingCardPage />} />

      <Route path={`${path}/templates`} render={() => <TemplatesPage />} />

      <Route path={`${path}/persons`} render={() => <PersonsPage />} />

      <Route exact path={`${path}/invoices`}>
        <Redirect to={{ pathname: `${path}/invoices/${InvoicesParserTab.Documents}`, state: location.state }} />
      </Route>

      <Route path={`${path}/hardware-packages`} render={() => <HardwarePackagesRouter />} />
    </Switch>
  );
};
